export default "__VITE_PUBLIC_ASSET__29e56877__"